// The AI Suggestion panel's decision buttons (Send, Escalate, Transfer to
// Support, Close - No Reply Needed, Spam) in one wrapping row (2026-10-12).
// When the panel is narrowed the row wraps, and the wrapped line used to sit
// only ~6px under the one above, so agents mis-clicked whatever landed under
// Send (Spam closes the contact at once). The same horizontal gap as before,
// with a clearly larger VERTICAL gap between wrapped lines. columnGap/rowGap
// on the flex container, so a row that doesn't wrap looks exactly as before.
// Every decision-button group uses this, so a new one picks up the spacing.
import { Stack } from '@mui/material'
import { DECISION_BUTTON_ROW_GAPS } from './decisionButtonRow.js'

export { DECISION_BUTTON_ROW_GAPS }

export default function DecisionButtonRow({ children, sx }) {
  return (
    <Stack direction="row" flexWrap="wrap" useFlexGap sx={{ ...DECISION_BUTTON_ROW_GAPS, ...sx }} data-testid="decision-button-row">
      {children}
    </Stack>
  )
}
